import { Location } from './location.model';
var Risk = /** @class */ (function () {
    function Risk() {
        this.location = new Location();
        this.riskCategory = null;
        this.riskQuantity = null;
        this.coverageType = null;
        this.clauses = [];
    }
    return Risk;
}());
export { Risk };
